import { Buffer } from 'buffer';
const bcUname = process.env.REACT_APP_API_USERNAME;
const bcpwd = process.env.REACT_APP_API_PASSWORD;
const REACT_APP_COMPANY = process.env.REACT_APP_COMPANY;
const REACT_APP_API_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_ACTIONS = process.env.REACT_APP_BIDDING_API_DATA_URL;

export const token = Buffer.from(`${bcUname}:${bcpwd}`, 'utf8').toString('base64');


export const prequalificationLines = `${REACT_APP_API_DATA_URL}prequalificationlines?${REACT_APP_COMPANY}`;
export const uOMApi = `${REACT_APP_API_DATA_URL}uOM?${REACT_APP_COMPANY}`;
export const Manufacturers = `${REACT_APP_API_DATA_URL}manufac?${REACT_APP_COMPANY}`;
export const Brands = `${REACT_APP_API_DATA_URL}brands?${REACT_APP_COMPANY}`;
export const prequalificationLineswithoutcompany = `${REACT_APP_API_DATA_URL}prequalificationlines`;
export const prequalificationheader =`${REACT_APP_API_DATA_URL}prequalificationheader?${REACT_APP_COMPANY}`;
export const prequalificationheaderNoCompany =`${REACT_APP_API_DATA_URL}prequalificationheader`;
export const productCategories = `${REACT_APP_API_DATA_URL}productCategories?${REACT_APP_COMPANY}`
export const DeleteBCLines = `${REACT_ACTIONS}DeleteAllLines?${REACT_APP_COMPANY}`;
export const submitPrequalification = `${REACT_ACTIONS}SubmitPrequalification?${REACT_APP_COMPANY}`;
export const companyDefault = REACT_APP_COMPANY;
